import React, { useEffect, useState } from "react";
import "./DisplayDates.css";
import Spinner from "../../Loader/Spinner";

import axios from "axios";
import { config } from "../../../confi";
import Modal from "./Modal";

function ReceiptList(props) {
  let avalible = props.status;

  // console.log(props.available);
  // console.log(props.res_data.dis_name);
  

  const [member_id, setmember_id] = useState("");
  const [miti_id, setmiti_id] = useState("");
  const [display_name, setdisplay_name] = useState("");
  const [name, setname] = useState("");
  const [year, setYear] = useState("");
  const [mobile, setmobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);
  const [mitis, setmitis] = useState("");
  const [display_history, setdisplay_history] = useState([]);
  const [modal_show, setmodal_show] = useState(false);
  const [total_amount, settotal_amount] = useState(null);
  const [paid_amount, setpaid_amount] = useState([]);
  const [member_row_id,Setmember_row_id] = useState('')
  
  
  useEffect(() => {
   
    if(props.res_data){

      setdisplay_name(props?.res_data?.dis_name? props.res_data.dis_name:"");
    }

   
  }, [props.res_data.dis_name]);





  const fetch_data = async (e) => {
    if (member_id === "") {
      return;
    }
    ///-----------------////
    setname("");
    setmiti_id("");
    setmobile("");
    setYear("");
    setmitis("");
    setdisplay_history("");
    settotal_amount("");
    setpaid_amount("");

    setmodal_show(false);
    try {
      const response = await props.fetch_miti(member_id);
      // console.log(response);

      // console.log(response.data.data[0]);

      if (response.status === 200 && response.data.status === "0") {
        if (
          response.data.data.length > 0 &&
          response.data.data[0].result !== null
        ) {
          console.log(response.data.data[0].result);

          setname(response.data.data[0].result.name_person);
          setmiti_id(response.data.data[0].result.miti_row_id);
          setmobile(response.data.data[0].result.mobile_no);
          setYear(response.data.data[0].result.membership_year);
          setmitis(response.data.data[0].result.miti);
          setdisplay_history(response.data.data[0].result.all_booked_date);
          settotal_amount(response.data.data[0].result.total_amount);
          setpaid_amount(response.data.data[0].result.recieve_amount);
          setmember_id(response.data.data[0].result.memberref_id)
          setdisplay_name(response.data.data[0].result.dis_name)
          Setmember_row_id(response.data.data[0].result.member_row_id)
          setmodal_show(true);
        } else {
        }
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  ///------------//////

  const submit_book = async (e) => {
    if (avalible === false) {
      return;
    }
    if (props.available === false) {
      return;
    }

    if (display_name === "") {
      return;
    }
    try {
      setLoading(true);
      const response = await props.book_date(
        miti_id,
        props.free_date,
        display_name,
        member_row_id
      );

      if (response.status === 200 && response.data.status === "0") {
        props.success_msg(props.no, "date slot booked");
        setmsg("date slot booked");
      } else {
        props.success_msg(props.no, "booking failed");
      }
      setLoading(false);

    } catch (error) {
       console.log(error)
       props.success_msg(props.no, "booking failed");
    }
    setLoading(false);
  };

  /// ----------------------- delete function ----////

  const handledelete = async () => {
    console.log("delete click");

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_bo_de",
      payload: { date_id: props.res_data.row_id },
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(response);

      if (response.status === 200 && response.data.status === "0") {
        // setmsg("success removed");
        props.success_msg(props.no, "Successfully Remove");
      } else {
      }
      setLoading(false);
    } catch (error) {

      console.log(error)
      props.success_msg(props.no, "not deleted try again")
    }
  };




  ///-----------------------
   async function dis_name_update (){

     try{   let reqbody = JSON.stringify({fn: "common_fun",an: "up_dis_na",payload: {name:display_name, date_id:props.res_data.row_id}});


    const response = await axios.post(
      `${config.apiBaseURL}/root`,
      { data: reqbody },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    
    if (response.status === 200 && response.data.status === "0") {
      props.success_msg(props.no, "Successfully updated");
    }
   else{
    props.success_msg(props.no, "not update try again")
   }

     }
     catch (err){

    console.log(err)
    props.success_msg(props.no, "not update try again")
 }







   }







  return (
    <>
      {loading ? (
        <p className="book_msg"></p>
      ) : (
        <div className="Receipt-card">
          <div className="num">{props.no}.</div>
          <div className="main-Receipt">
            <div>
              <input
                type="text"
                value={props.res_data.membership_rec_no || member_id}
                disabled={props.inputDisabled}
                onChange={(e) => setmember_id(e.target.value)}
              />
              <button
                className="a-fetch-button"
                disabled={props.buttonDisabled}
                onClick={fetch_data}
              >
                Fetch
              </button>
            </div>
            <div>
              <p>
                Member Name&nbsp;:&nbsp;{props.res_data.name_person || name}{" "}
              </p>
              <p>
                <span style={{ marginRight: "2em" }}>
                  Membership Year&nbsp;:&nbsp;
                  {props.res_data.membership_year || year}
                </span>
                <span>
                  Mobile No&nbsp;:&nbsp; {props.res_data.mobile_no || mobile}
                </span>
              </p>
            </div>
            <div>
              <label style={{ marginRight: "2em" }}>Display Name</label>
              <input
                style={{ background: "#fdfa8e" }}
                type="text"
                value={display_name}
                onChange={(e) => setdisplay_name(e.target.value)}
                // disabled={props.inputDisabled}
              />
              <button
                className="a-fetch-button"
                onClick={props.res_data.row_id ? dis_name_update :submit_book}
                // disabled={props.buttonDisabled}
              >
             { props.res_data.row_id ?  'Update' : 'Submit'}
              </button>
              <div>
                {modal_show && (
                  <Modal
                    mitis={mitis}
                    display_history={display_history}
                    total_amount={total_amount}
                    paid_amount={paid_amount}
                  />
                )}
              </div>

              {props.res_data.row_id && (
                <button
                  style={{ borderRadius: "12px", padding: "8px 1.5em" }}
                  onClick={handledelete}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ReceiptList;
